import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GuiZone} from '@catcore/types/api-v2';
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class GuiZoneService {

  BASE_URL_GUI_ZONES = '/api/gui-zones/';

  PARENTS_ENDPOINT = '/parents';

  CHILDREN_ENDPOINT = '/children';

  constructor(private http: HttpClient,
              private genericResourceService: GenericResourceService) {
  }

  /**
   * Requests the parents for a given GUI zone
   *
   * @param {GuiZone} guiZone
   * @returns {Observable<any>}
   */
  getParentsFor(guiZone: GuiZone) {
    const url = this.BASE_URL_GUI_ZONES + guiZone.id + this.PARENTS_ENDPOINT;
    return this.http.get(url).map((res) => res);
  }

  /**
   * Request the children for a given GUI zone
   *
   * @param {GuiZone} guiZone
   * @returns {Observable<any>}
   */
  getChildrenFor(guiZone: GuiZone) {
    const url = this.BASE_URL_GUI_ZONES + guiZone.id + this.CHILDREN_ENDPOINT;
    return this.http.get(url).map((res) => res);
  }

  /**
   * Saves the new list of parents/children to the affected GUI zone.
   *
   * @param affected Zone from which the parent/child is deleted
   * @param list New list of parents/children
   * @param {boolean} parentDeleted Flag if parent/child was deleted
   * @returns {Observable<any>}
   */
  saveList(affected, list, parentDeleted: boolean): Observable<any> {
    let guiZone;
    // depending of parent or child use different property for data
    if (parentDeleted) {
      guiZone = {
        _links: {self: {href: affected._links.self.href}},
        parents: list.map((zone) => zone.raw),
      };
    } else {
      guiZone = {
        _links: {self: {href: affected._links.self.href}},
        children: list.map((zone) => zone.raw),
      };
    }
    // use resource service to send customPut containing new list
    return this.genericResourceService
      .findServiceForResource(guiZone._links.self.href)
      .save(guiZone);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/gui-zone/gui-zone.service.ts